import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/home.vue';
import Works from '@/views/works/works.vue';
import Works_content from '@/components/worksContent';
import ScratchWork from '@/views/scratchwork/scratchwork';
import Myworks from '@/views/myWorks/myWorks';
import ScratchWorksPlay from '@/views/scratchWorksPlay/scratchWorksPlay';
import personHome from '@/views/personHome/personHome';
import Python from '@/views/python/python';
import Notification from '@/components/notification';
import Myexam from '@/views/exam/myexam';
import ReadyExam from '@/views/exam/readyExam';
import ErrorPage from '@/components/error';
import TestPaper from '@/components/testPaper';
import Scratch from '@/views/scratch/scratch';
import Lesson from '@/views/lesson/lesson';
import Download from '@/views/download/download';
import Cpa from '@/views/cpa/cpa';
import MatchList from '@/views/match/matchList';
import MatchDetail from '@/views/match/matchDetail';
import MatchWorks from '@/views/match/matchWorks';
import Classroom from '@/views/classroom1/index';
import PlayCode from '@/views/kexie/kexie';
import Resource from '@/views/resource/resource';
import Board from '@/views/board/board';
Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    routes: [
        {
            path: '/',
            redirect: '/home'
        }, {
            path: '/home',
            name: 'home',
            component: Home
        }, {
            path: '/error',
            name: 'error',
            component: ErrorPage
        }, {
            path: '/lesson',
            name: 'lesson',
            component: Lesson
        }, {
            path: '/sh',
            name: 'sh',
            component: Scratch
        }, {
            path: '/testPaper',
            name: 'testPaper',
            component: TestPaper
        }, {
            path: '/works',
            name: 'works',
            component: Works
        }, {
            path: '/workcontent/:id',
            component: Works_content,
        }, {
            path: '/scratchworks/:id',
            component: ScratchWork,
        }, {
            path: '/worksplay/:id',
            component: ScratchWorksPlay,
        }, {
            path: '/myexam',
            name: 'myexam',
            component: Myexam
        }, {
            path: '/readyExam',
            name: 'readyExam',
            component: ReadyExam
        }, {
            path: '/mywork',
            name: 'myworks',
            component: Myworks
        }, {
            path: '/personhome',
            name: 'personhome',
            component: personHome
        }, {
            path: '/notification',
            name: 'notification',
            component: Notification
        }, {
            path: '/py',
            name: 'py',
            component: Python
        }, {
            path: '/download',
            name: 'download',
            component: Download
        }, {
            path:'/cpa',
            name:'cpa',
            component:Cpa
        }, {
            path: '/match',
            name: 'match',
            component: MatchList,
        }, {
            path: '/matchDetail',
            name: 'matchDetail',
            component: MatchDetail,
        }, {
            path: '/matchWorks/:id',
            component: MatchWorks,
        }, {
            path: '/classroom',
            name: 'classroom',
            component: Classroom,
        }, {
            path: '/playCode',
            name: 'playCode',
            component: PlayCode,
        }, {
            path: '/resource',
            name: 'resource',
            component: Resource
        }, {
            path: '/board',
            name: 'board',
            component: Board
        }
        
        
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js